import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import dayjs from 'dayjs'
import { DATE_FORMAT_FULL } from '../../../constants/global'
import useAxios from '../../../hooks/useAxios'
import { useEffect } from 'react'

interface Props {
  setOptions: any
  options: any
}

interface PickUpTimeSlot {
  date: string
  pickup_time: string
  slots: {
    pickup_time_range: string
    pickup_time_range_id: string
  }[]
}

export const OptionsSpxExpress = (props: Props) => {
  const { setOptions, options } = props

  useEffect(() => {
    setOptions({
      ...options,
      pickUpType: 'branch',
      pickUpTime: 'no',
      pickUpTimeId: 0,
      pickupTimeRange: '',
      isPickup: false,
    })
  }, [])

  const { data, isLoading } = useAxios<{ data: PickUpTimeSlot[] }>({
    url: '/trackings/spx/pickupTimeslot',
    method: 'GET',
  })

  const pickUpTimeSlots = data?.data || []

  return (
    <>
      <Grid item xs={12} lg={6}>
        <FormControl variant="filled" fullWidth>
          <InputLabel id="typeSender-label">ประเภทการส่ง</InputLabel>
          <Select
            id="typeSender"
            name="typeSender"
            labelId="typeSender-label"
            value={options?.pickUpType ?? 'branch'}
            onChange={(e) =>
              setOptions({
                ...options,
                pickUpType: e.target.value,
                pickUpTime: 'no',
                pickUpTimeId: 0,
                pickupTimeRange: '',
                isPickup: e.target.value === 'home',
              })
            }
            fullWidth
          >
            <MenuItem disabled value="" selected>
              <em>เลือกประเภทการส่ง</em>
            </MenuItem>
            <MenuItem value={'branch'}>ส่งที่สาขาเอง</MenuItem>
            <MenuItem value={'home'}>เรียกรถเข้ารับ</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} lg={6}>
        <FormControl variant="filled" fullWidth>
          <InputLabel id="typeProduct-label">วันที่</InputLabel>
          <Select
            id="pickUpTime"
            name="pickUpTime"
            labelId="pickUpTime-label"
            disabled={options?.pickUpType === 'branch'}
            value={options?.pickUpTime ?? 'no'}
            onChange={(e) =>
              setOptions({
                ...options,
                pickUpTime: e.target.value,
                pickupTimeRangId: 0,
                pickupTimeRange: '',
              })
            }
            fullWidth
          >
            <MenuItem value="no" selected>
              เลือกวันที่
            </MenuItem>
            {pickUpTimeSlots.map((item, index: number) => (
              <MenuItem value={item.pickup_time} key={index}>
                {item.date}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} lg={6}>
        <FormControl variant="filled" fullWidth>
          <InputLabel id="isGuarantee-label">ช่วงเวลา</InputLabel>
          <Select
            id="pickUpTimeId"
            name="pickUpTimeId"
            labelId="pickUpTimeId-label"
            value={options?.pickupTimeRangId ?? 0}
            disabled={options?.pickUpType === 'branch'}
            onChange={(e) => {
              const pickupTimeRangId = e.target.value
              const pickupTimeRange = pickUpTimeSlots
                .find((item) => item.pickup_time === options?.pickUpTime)
                ?.slots.find(
                  (slot) => slot.pickup_time_range_id === pickupTimeRangId,
                )?.pickup_time_range
              setOptions({
                ...options,
                pickupTimeRangId,
                pickupTimeRange,
              })
            }}
            fullWidth
          >
            <MenuItem value={0} selected>
              เลือกช่วงเวลา
            </MenuItem>
            {pickUpTimeSlots
              .map((item, index: number) => {
                if (item.pickup_time === options?.pickUpTime) {
                  return item.slots.map((slot, index) => (
                    <MenuItem value={slot.pickup_time_range_id} key={index}>
                      {slot.pickup_time_range}
                    </MenuItem>
                  ))
                }
              })
              .filter((item) => item)}
          </Select>
        </FormControl>
      </Grid>
    </>
  )
}
